import { LocalStorage } from '@app/utils/storage';

export class ClientAreaStorage {
  static saveToken(id: string | number, token: string) {
    LocalStorage.setItem(`ltdca-${id}`, token);
  }

  static getToken(id: string | number) {
    return LocalStorage.getItem(`ltdca-${id}`);
  }

  static removeToken(id: string | number) {
    LocalStorage.removeItem(`ltdca-${id}`);
  }
}
